module.exports = __webpack_public_path__ + "img/screenshot-2-15.35b8bc45.jpg";